<template>
    <b-col
            :id="id"
            class="property-listing-card p-1 col-xxxl-4 col-xxxll-3"
            sm="6"
            :md="isNearbyPropertiesPage ? '6' : '12'"
            lg="6"
    >
        <b-card
                no-body
                class="property-card"
                @mouseover="emitCardMouseoverEvent"
                @mouseleave="emitCardMouseleaveEvent"
        >
            <router-link
                    :to="propertyDetailsLink()"
                    class="text-decoration-none"
            >
                <b-row no-gutters>
                    <b-col>
                        <property-listing-card-header
                                :property-app-resource="propertyAppResource"
                                :show-controls="showControls"
                        />
                    </b-col>
                </b-row>
                <b-row no-gutters>
                    <b-col
                            class="pl-3 pb-2 pt-2"
                            cols="9"
                    >
                        <property-listing-card-details
                                :property-app-resource="propertyAppResource"
                        />
                    </b-col>
                    <b-col
                            cols="3"
                            class="favorite pl-2 pt-4"
                    >
                        <property-listing-card-favorite-button
                                :property-app-resource="propertyAppResource"
                                :hide-on-balloon="false"
                                :display-button-icon-only="false"
                                :favorite-option-enabled="!isMyHome && favoriteOptionEnabled"
                        />
                    </b-col>
                </b-row>
                <b-row
                       v-if="attribution"
                       no-gutters
                >
                    <b-col
                            cols="12"
                            class="compliance-attribution pl-3 pb-2 pt-2"
                    >
                        <div class="attribution">
                            <span
                                class="text"
                            >
                                {{ attribution.lexicon }}
                            </span>
                        </div>
                    </b-col>
                </b-row>
                <b-row no-gutters>
                    <b-col>
                        <property-listing-card-footer
                                :property-app-resource="propertyAppResource"
                                :hide-on-balloon="false"
                        />
                    </b-col>
                </b-row>
            </router-link>
        </b-card>
    </b-col>
</template>

<script>
    import "./PropertyListingCard.scss";
    import PropertyListingCardHeader from "./PropertyListingCardHeader";
    import PropertyListingCardDetails from "./PropertyListingCardDetails";
    import PropertyListingCardFooter from "./PropertyListingCardFooter";
    import AppResource from "@milestoneslabs/milestones-js-engine/src/Data/AppResource";
    import PropertyListingCardFavoriteButton from "./PropertyListingCardFavoriteButton";
    import {SEARCH_TABS} from '../../../helpers/variables';
    import IsMobileMixin from "@milestoneslabs/milestones-ui-kit/src/mixins/IsMobileMixin";
    import set from 'lodash/set';
    import {mapGetters} from "vuex";
    import PropertyAppResource from "@milestoneslabs/milestones-core-js/src/AppResources/PropertyAppResource";

    export const PROPERTY_LISTING_CARD_MOUSE_ENTER = 'PropertyListingCard:mouse-enter';
    export const PROPERTY_LISTING_CARD_MOUSE_LEAVE = 'PropertyListingCard:mouse-leave';

    export default {
        name: "PropertyListingCard",
        components: {
            PropertyListingCardFavoriteButton,
            PropertyListingCardFooter, PropertyListingCardDetails, PropertyListingCardHeader
        },
        props: {
            propertyDetailsRoute: {
                type: [String, Object],
                default: 'property.details.view',
            },
            propertyAppResource: {
                type: Object,
                required: true,
                validator(value){
                    return value.constructor.name === (new PropertyAppResource()).constructor.name;
                }
            },
            favoriteOptionEnabled: {
                type: Boolean,
                default: true,
            }
        },
        mixins: [IsMobileMixin],
        data() {
            return {
                id: 0,
                showControls: false,
                attribution: null,
            };
        },
        computed: {
            ...mapGetters({
                coreProperty: 'getCoreProperty',
            }),
            isMyHome() {
                if (!this.coreProperty) {
                    return false;
                }
                return this.propertyAppResource.uuid === this.coreProperty.uuid;
            },
            isNearbyPropertiesPage() {
                return this.$route.name === 'nearby.app.search-properties';
            }
        },
        methods: {
            propertyDetailsLink() {
                if (this.isMyHome) {
                    return {name: 'dashboard'};
                }

                let detailsRoute = typeof this.propertyDetailsRoute === 'string'
                    ? {name: this.propertyDetailsRoute}
                    : this.propertyDetailsRoute;

                if (!detailsRoute.params) {
                    detailsRoute.params = {};
                }
                detailsRoute.params.id = this.propertyAppResource.uuid;

                if (this.isMobile) {
                    set(detailsRoute, 'query.searchTab', SEARCH_TABS.LIST);
                }

                return detailsRoute;
            },
            emitCardMouseoverEvent() {
                this.$bus.$emit(PROPERTY_LISTING_CARD_MOUSE_ENTER, this.propertyAppResource.uuid);
                this.showControls = true;
            },
            emitCardMouseleaveEvent() {
                this.$bus.$emit(PROPERTY_LISTING_CARD_MOUSE_LEAVE, this.propertyAppResource.uuid);
                this.showControls = false;
            },
        },
        beforeMount() {
            this.id = this.propertyAppResource.uuid;
        },
        mounted() {
            if (
                !this.propertyAppResource.compliance ||
                !this.propertyAppResource.compliance.summary ||
                !this.propertyAppResource.compliance.summary.attribution
            ) {
                this.attribution = null;
                return;
            }

            this.attribution = {
                lexicon: this.propertyAppResource.compliance.summary.attribution.lexicon,
            };
        }
    };
</script>
